import React from 'react';

const Privacy = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="section-light py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h1 className="page-title text-center mb-8">Privacy Policy</h1>
            <div className="bg-white p-8 rounded-lg shadow-lg">
              
              <div className="prose max-w-none text-gray-700 leading-relaxed space-y-6">
                <p className="text-lg">
                  At Here Come Protection.com, your privacy is important to us. We collect personal 
                  information such as your name, email, phone number, and insurance details solely 
                  to provide you with insurance quotes, process your requests, and communicate with you.
                </p>

                <div>
                  <h2 className="text-2xl font-bold text-primary-blue mb-4">Information We Collect</h2>
                  <p>
                    We collect information you provide directly to us, such as when you:
                  </p>
                  <ul className="list-disc list-inside mt-2 space-y-1">
                    <li>Request a quote through our website</li>
                    <li>Contact us via phone, email, or our contact form</li>
                    <li>Upload documents such as declarations pages</li>
                    <li>Schedule consultations or meetings</li>
                  </ul>
                </div>

                <div>
                  <h2 className="text-2xl font-bold text-primary-blue mb-4">How We Use Your Information</h2>
                  <p>
                    We use the information we collect to:
                  </p>
                  <ul className="list-disc list-inside mt-2 space-y-1">
                    <li>Provide insurance quotes and recommendations</li>
                    <li>Process your insurance applications and requests</li>
                    <li>Communicate with you about our services</li>
                    <li>Respond to your questions and provide customer support</li>
                    <li>Comply with legal and regulatory requirements</li>
                  </ul>
                </div>

                <div>
                  <h2 className="text-2xl font-bold text-primary-blue mb-4">Information Sharing</h2>
                  <p>
                    We do not sell or share your information with third parties except when necessary 
                    to complete your insurance request or as required by law. This may include sharing 
                    information with:
                  </p>
                  <ul className="list-disc list-inside mt-2 space-y-1">
                    <li>Insurance carriers to obtain quotes and process applications</li>
                    <li>Service providers who assist in our operations (under confidentiality agreements)</li>
                    <li>Regulatory authorities when required by law</li>
                  </ul>
                </div>

                <div>
                  <h2 className="text-2xl font-bold text-primary-blue mb-4">Data Security</h2>
                  <p>
                    Any documents you upload (including declarations pages) are securely stored and 
                    used only for quoting purposes. We use industry-standard security measures to 
                    protect your information, including:
                  </p>
                  <ul className="list-disc list-inside mt-2 space-y-1">
                    <li>Secure data transmission (HTTPS/SSL encryption)</li>
                    <li>Secure file storage systems</li>
                    <li>Access controls and authentication</li>
                    <li>Regular security assessments</li>
                  </ul>
                </div>

                <div>
                  <h2 className="text-2xl font-bold text-primary-blue mb-4">Your Rights</h2>
                  <p>
                    You have the right to:
                  </p>
                  <ul className="list-disc list-inside mt-2 space-y-1">
                    <li>Access the personal information we have about you</li>
                    <li>Request corrections to your personal information</li>
                    <li>Request deletion of your personal information (subject to legal requirements)</li>
                    <li>Opt out of marketing communications</li>
                  </ul>
                </div>

                <div>
                  <h2 className="text-2xl font-bold text-primary-blue mb-4">Consent</h2>
                  <p>
                    By submitting your information through this site, you consent to our use of your 
                    data as described in this privacy policy. You may withdraw your consent at any 
                    time by contacting us.
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-bold text-primary-blue mb-4">Contact Us</h2>
                  <p>
                    Questions about this privacy policy or how we handle your information? 
                    Contact us at:
                  </p>
                  <div className="mt-4 p-4 bg-cream rounded-lg">
                    <p className="font-semibold">Here Come Protection.com</p>
                    <p>
                      Email: <a href="mailto:herecomesprotection@gmail.com" className="text-accent-orange hover:text-rust-amber">herecomesprotection@gmail.com</a>
                    </p>
                    <p>
                      Phone: <a href="tel:(972)292-8640" className="text-accent-orange hover:text-rust-amber">(972) 292-8640</a>
                    </p>
                  </div>
                </div>

                <div className="border-t pt-6 mt-8">
                  <p className="text-sm text-gray-500">
                    This privacy policy was last updated on {new Date().toLocaleDateString()}. 
                    We may update this policy from time to time, and will notify you of significant changes.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Privacy;